
const state = () => ({
  // 用户信息
  userInfo: {
    isLogin: false
  },
  // 运营或广告数据
  locsData: {},
  // 右侧推广视频
  recommendData: []
})

export default state


